import { css } from "styled-components/macro";
import { distinctArray } from "./arrayUtils";

export const breakpoints = {
  xxs: { maxWidth: 374 },
  xs: { maxWidth: 575 },
  sm: { minWidth: 576 },
  md: { minWidth: 768 },
  lg: { minWidth: 992 },
  xl: {
    minWidth: 1200,
  },
};

export const slickBreakpoints = {
  iphone5: 350,
  mobile: 550,
  tablet: 960,
};

const getMediaBody = (mediaQuery, args) =>
  args && args.lenght ? `${mediaQuery} { ${css(...args)} }` : mediaQuery;

export const media = Object.keys(breakpoints).reduce((acc, label) => {
  const breakpoint = breakpoints[label];

  const limites = [
    breakpoint.minWidth ? `(min-width: ${breakpoint.minWidth / 16}em)` : "",
    breakpoint.maxWidth ? `(max-width: ${breakpoint.maxWidth / 16}em)` : "",
  ].filter((x) => x);

  const mediaQuery = ["@media all"].concat(limites).join(" and ");

  acc[label] = (...args) => {
    return getMediaBody(mediaQuery, args);
  };
  return acc;
}, {});

export const zIndexes = {
  base: 0,
  widget: 50,
  header: 100,
  footer: 100,
  glass: 1000,
  modal: 1025,
};

export const hexToRGBA = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const resolveClassNames = (...classNames) =>
  distinctArray(
    classNames
      .filter((className) => className)
      .map((className) => className.trim())
  ).join(" ");
